// extracted by mini-css-extract-plugin
export default {"primary-footer":"footer_primary-footer__Cg3PQ","footer-items":"footer_footer-items__6NNSd","footerItems":"footer_footerItems__xwEzU"};